import { Box } from '@mui/material';
import { Button, Typography } from '@sweep-io/sweep-design';

interface TableActionableEmptyStateProps {
  title: string;
  buttonLabel: string;
  onButtonClick: () => void;
  marginTop?: string | number;
}

export const TableActionableEmptyState = ({
  title,
  buttonLabel,
  onButtonClick,
  marginTop = '160px',
}: TableActionableEmptyStateProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        textAlign: 'center',
        alignItems: 'center',
        marginTop,
      }}
    >
      <Typography variant="h4">{title}</Typography>
      <Button onClick={onButtonClick}>{buttonLabel}</Button>
    </Box>
  );
};
